package diana.soleil.design.iraniancanadienbazzar.core.designsystem.component

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.widthIn
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.model.AppearanceMode

/**
 * Segmented System / Light / Dark selector, mirroring [LanguageSwitcher]. [labelFor] supplies each
 * mode's localized display name — this component contains no copy (golden rule 6).
 */
@Composable
fun AppearanceSwitcher(
    selected: AppearanceMode,
    onSelect: (AppearanceMode) -> Unit,
    labelFor: (AppearanceMode) -> String,
    modifier: Modifier = Modifier,
) {
    Row(
        // Capped so the segments stay a control on desktop web instead of stretching to a
        // third of the card each (see sizes.segmentedMaxWidth).
        // widthIn BEFORE fillMaxWidth, deliberately: fillMaxWidth pins minWidth to the full
        // available width, and a later widthIn(max=) loses to that min — the cap silently did
        // nothing. Capping the max first, then filling, gives equal segments at 420dp.
        modifier = modifier.widthIn(max = AppTheme.sizes.segmentedMaxWidth).fillMaxWidth(),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        AppearanceMode.entries.forEach { mode ->
            AppChip(
                label = labelFor(mode),
                selected = mode == selected,
                onClick = { onSelect(mode) },
                modifier = Modifier.weight(1f),
            )
        }
    }
}
